import has from 'lodash/has';
import React from 'react';
import {createEventHandler} from 'recompose';
import fuse from '../../_libs/redux-fusion';
import {FormModalHOC, modalOptions} from '../../components/modals/FormModal';
import {buildUpdateRequestModal} from '../../config/redux-list/requestModals';
import {getAsString, getId} from '../../core-utilities/domain/ReduxUtils';
import {getModalSubState} from '../../core-utilities/redux-request-modal/utils';
import {createReduxDropdownList} from '../../core-utilities/redux/ReduxDropdownListContainer';
import {applyDefaultReduxListComponentOptions} from '../../core-utilities/redux/ReduxListContainer';
import {PeopleItem} from '../../personnel/components/PeopleItem';
import {applySortOptions} from '../../personnel/redux/peopleConfig';
import {reduxList as peopleReduxList} from '../../personnel/redux/peopleSelectorList';
import {OrganizationForm} from '../components/OrganizationForm';
import {ORGANIZATION_COLLECTION} from '../domain/config';
import {logger} from './logger';


export function makeEditOrgModal(config) {
  const {
    prefix,
    getState,
  } = config;

  const OrganizationFormContainer = fuse(StreamedComponent(peopleReduxList, getState))(OrganizationForm);

  const EditOrganizationFormModal = FormModalHOC(OrganizationFormContainer, {
    modalHeaderLabel: 'organizations.edit.header.label',
  }, {
    showPoc: true,
  });

  return buildUpdateRequestModal({
    prefix,
    getState,
    path: ORGANIZATION_COLLECTION,
    buildOnSave,
    modalOptions: modalOptions,
    modalComponent: EditOrganizationFormModal,
    logger,
  });
}

function buildOnSave(state$, dispatch, props$, actions, model$) {
  const {
    handler: onSave,
    stream: save$,
  } = createEventHandler();

  save$
    .withLatestFrom(model$)
    .takeUntil(props$.last())
    .subscribe(([body, model]) => {
      const request = {
        body: getUpdateRequest(body),
        data: model,
      };
      dispatch(actions.sendRequest(request));
    });

  return onSave;
}

function getUpdateRequest(data) {
  return {
    ...data,
    poc: void 0,
    pocId: has(data, 'poc') ? getId(data.poc) : void 0,
  };
}

function StreamedComponent(peopleReduxList, getState) {
  return (state$, dispatch) => (props$) => {
    const componentOptions = applyDefaultReduxListComponentOptions(peopleReduxList.options, {
      applySortOptions,
      excludeFilterModalOptions: true,
      useInitFilter: true,
    });

    const filterOptions = {
      includeTeams: false,
      expandTeams: false,
      includeUsers: true,
      includeNonUsers: false,
    };

    const orgId$ = state$
      .map(getState)
      .map(getModalSubState)
      .map(state => getId(state.model))
      .distinctUntilChanged()
      .takeUntil(props$.last());

    const propsToList$ = props$
      .combineLatest(
        orgId$,
        (props, orgId) => ({
          ...props,
          orgId,
          filterOptions,
        }));

    const {
      dropdownProps$: pocProps$,
    } = createReduxDropdownList({
      listProp: 'pocProps',
      getParentId: props => props.orgId,
      getLabel: getAsString,
      reduxList: peopleReduxList,
      options: componentOptions,
      state$,
      dispatch,
      props$: propsToList$,
      baseFilterData: {filterOptions},
    });

    return props$
      .combineLatest(
        pocProps$,
        (props, pocProps) => ({
          ...props,
          ...pocProps,
        }));
  };
}



// WEBPACK FOOTER //
// ./src/js/organizations/redux/configEditOrgRequests.js